// src/services/adminDatasetService.js
import { apiRequest } from '../api/client';
import { endpoints } from '../api/endpoints';

export function getAllDatasetVersions() {
    return apiRequest(endpoints.AdminListDatasetVersions, {
        method: 'GET',
    });
}

export function updateDatasetVersion(id, { doi, description, license }) {
    return apiRequest(endpoints.AdminUpdateDatasetVersion(id), {
        method: 'PUT',
        body: JSON.stringify({ doi, description, license }),
    });
}
